<template>
  
  <div>
    <cliente-modal-component></cliente-modal-component>

    <div class="row">
      </div>
        <card card-body-classes="table-full-width">
          <div slot="header">
            <h4 class="card-title">Lista de Clientes</h4>
          </div>
          <div class="row px-3">
            <div class="col-md-6">
              <router-link to="/clientes/aniversariantes" class="btn btn-info mx-auto-mobile mb-2-mobile"  tag="a">
                <i class="fa fa-gift"></i> Aniversariantes
              </router-link>
            </div>
            <div class="col-md-6">
              <download-excel
                    :fetch="fetchData"
                    :title="'Relatório de Clientes'"
                    name="Clientes.xls"
                    class="d-inline-block pull-right"
              > 
                <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Exportar Excel</n-button>
              </download-excel>
            </div>
          </div>
          <div class="px-3">
            <div class="mb-3">
              <div v-for="cliente of clientes" class="row py-2 px-2 bordered-block-table only-mobile">
                <div class="col-6">
                  <strong>{{ cliente.nome_razao}}</strong>
                  <br>
                  Documento: {{ cliente.cpf_cnpj }}
                </div>
                <div class="col-4">
                  E-mail: {{ cliente.email}}
                  <br>
                  Tel: {{ cliente.telefone}}
                </div>
                <div class="col-2">
                  <button class="btn btn-sm btn-info px-2 py-1 " @click="openCliente(cliente)" data-toggle="modal" style="font-size: 10px"><i class="fa fa-info"></i></button>
                </div>
              </div>
            </div>

            <table class="display responsive nowrap table table-hover table-striped  hidden-mobile">
              <thead>
                <tr>  
                  <th style="width: 300px">Nome</th>
                  <th class="">Documento</th>
                  <th class="pr-4">Telefone</th>
                  <th class="">E-mail</th>
                  <th class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cliente of clientes">
                  <td class="">{{ cliente.nome_razao }}</td>
                  <td class="">{{ cliente.cpf_cnpj }}</td>
                  <td class="pr-3">{{ cliente.telefone }}</td>
                  <td class="pr-3">{{ cliente.email }}</td>
                  <td class="text-right">
                    <button class="btn btn-sm btn-info px-2 py-1" @click="openCliente(cliente)" style="font-size: 10px"><i class="fa fa-info"></i></button>
                  </td>
                </tr>
                <tr v-if="!clientes || !clientes.length">
                  <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
                </tr>
              </tbody>
            </table>

            <div class="row">
              <div class="col-12 col-md-6 text-center-mobile">
                Mostrando de {{ from }} até {{ to }} de {{ total}} registros
              </div>
              <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
                <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
  import moment from 'moment'
  import ClienteService from '@/services/ClienteService.js'
  import VendaService from '@/services/VendaService.js'
  import ClienteModalComponent from '@/components/Modals/ClienteModalComponent.vue'

  export default {
    components: {
      Card,
      ClienteModalComponent,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        clientes: [],
        current_page: 1,
        current_page_historico: 1,
        pageCount: 0,
        pageCount_historico: 0,
        vendas:[],
        query: "",
        from: 0,
        from_historico: 0,
        cliente:{},
        to: 0,
        to_historico:0,
        total_vendas:{},
        total_historico:0,
        total: 0,
      }
    },
    methods:{
      loadClientes() {
        ClienteService.load(`?page=${this.current_page}&query=${this.query}`).then(res => {
          this.clientes = res.data.data
          
          this.pageCount = res.data.last_page
          this.from = res.data.from
          this.to = res.data.to
          this.total = res.data.total
        })
      },
      search() {
        this.current_page = 1
        this.loadClientes()
      },
      changePage(page) {
        this.current_page = page
        this.loadClientes()
      },

      openCliente(cliente) {
        this.$modal.show('cliente-modal-component', { cliente: cliente})
      },
      async fetchData() {
        let loader = this.$loading.show()

        let response = await ClienteService.load(`?query=${this.query}&no_paginate=true`)
        let dados = []

        for(let item of response.data) {
          let tmp = {};
          tmp.Nome = item.nome_razao;
          tmp.Telefone = item.telefone
          tmp.Email = item.email
          tmp.Endereço = item.endereco
          tmp.Número = item.numero
          tmp.Complemento = item.complemento
          tmp.Bairro = item.bairro
          tmp.Cidade = item.cidade

          dados.push(tmp)
        }
        loader.hide();
        return dados;


      }
    },
    mounted() {
      this.loadClientes()
    }
  }
</script>